export default "__VITE_ASSET__CaFtDXl___"